import { MapFeature } from './map-feature'
import { isDeepEqual } from './compare'
import { useStyles } from './selected-area.style'

export const SelectedArea = ({ projection, selectedFeature, scale, isLayerEnabled, isZoomedIn, onClick }) => {
  const classes = useStyles()

  return <MapFeature
    pathDefinition={projection.path(selectedFeature.feature)}
    color={scale(selectedFeature.data.value)}
    isSelected={true}
    showOutline={!isLayerEnabled || isZoomedIn}
    isZoomedIn={isZoomedIn}
    className={onClick ? classes.clickable : ''}
    onClick={(event) => {
      if (onClick) {
        onClick(event, selectedFeature)
      }
    }}
  />
}

export const areSelectedAreasEqual = (prev, next) => (isDeepEqual(prev.selectedFeature, next.selectedFeature))
